import { Injectable } from "@angular/core";
import { observable, Observable, of } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { EnhancementsEntity } from "app/interfaces/enhancements.model";
import { BenefitsEntity } from "app/interfaces/benefits.model";
import { CommonLanguageModel } from "app/interfaces/language.model";
import { CountryModel } from "app/interfaces";
import { AddressModel } from "app/interfaces/address.model";
import { map, tap } from "rxjs/operators";
import { InstitutesFromJobOfferIdModel } from "app/interfaces/institutes-from-job-offer-id.model";
import { StudyTagsFromJobOfferIdModel } from "app/interfaces/study-tags-from-job-offer-id.model";
import { TagsFromJobOfferIdModel } from "app/interfaces/tags-from-job-offer-id.model";

@Injectable()
export class CommonService {
  private jobMacroStudyTags: any = null;

  private _jobFromUrl: any = null;

  constructor(private http: HttpClient) {
    console.log("common loaded", new Date().getTime());
    this.http
      .get(
        environment.baseUrlWs +
        environment.wsVerison +
        `employer/job-macro-study-tags`
      )
      .toPromise()
      .then((r) => (this.jobMacroStudyTags = r));
  }

  getData(dataType: string): Observable<Object[]> {
    return this.http.get<any[]>(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/" +
      dataType +
      "/?all=1"
    );
  }
  getSectors(): Observable<Object[]> {
    return this.http.get<any[]>(
      environment.baseUrlWs + environment.wsVerison + "employer/sectors/?all=1"
    );
  }

  getTypes(): Observable<Object[]> {
    return this.http.get<any[]>(
      environment.baseUrlWs + environment.wsVerison + "employer/types/?all=1"
    );
  }

  getCountries(): Observable<Object[]> {
    return this.http.get<Object[]>(
      environment.baseUrlWs + environment.wsVerison + "employer/countries"
    );
  }

  getCities(country_id: number): Observable<any> {
    return this.http.get<Object[]>(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/countries/" +
      country_id +
      "/cities"
    );
  }

  getUniversities(idCity: number): Observable<Object[]> {
    return this.http.get<Object[]>(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/cities/" +
      idCity +
      "/universities"
    );
  }

  getFaculties(): Observable<Object[]> {
    return this.http.get<Object[]>(
      environment.baseUrlWs + environment.wsVerison + "employer/faculty-tags"
    );
  }

  getUniversityByName(name: string) {
    return this.http.get(
      environment.baseUrlWs +
      environment.wsVerison +
      "universities?name=" +
      name
    );
  }

  getSkillsByName(name: string) {
    return this.http.get(
      environment.baseUrlWs +
      environment.wsVerison +
      "skills_by_name?name=" +
      name
    );
  }

  getCitiesByName(name: string) {
    return this.http.get(
      environment.baseUrlWs + environment.wsVerison + "cities?name=" + name
    );
  }

  getLanguagesByName(name: string) {
    return this.http.get(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/languages?name=" +
      name
    );
  }

  getLanguageLevels(language_id: number) {
    return this.http.get(
      environment.baseUrlWs +
      environment.wsVerison +
      "language_levelss?id=" +
      language_id
    );
  }

  isImgFromFb(img) {
    if (!img) {
      return false;
    }
    return img.indexOf("scontent.xx") > -1 || img.indexOf("lookaside") > -1;
  }

  setApplicationViewed(id) {
    return this.http.put(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/jobs/" +
      id +
      "/curriculum-set-viewed",
      {}
    );
  }

  setCheckInViewed(id) {
    return this.http.put(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/events/" +
      id +
      "/check-in-set-viewed",
      {}
    );
  }

  setEmployersUsersViewed(users_id) {
    return this.http.put(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/curricula/set-viewed/" +
      users_id,
      {}
    );
  }

  getIndustriesByName(name: string) {
    return this.http.get(
      environment.baseUrlWs +
      environment.wsVerison +
      "industries_by_name?name=" +
      name
    );
  }

  getGeolocations(query: string) {
    let _params = new HttpParams();
    if (query) {
      _params = _params.append("query", query);
    }

    _params = _params.append("page", '0');
    _params = _params.append("limit", '500');

    return this.http
      .get(
        environment.baseUrlWs + environment.wsVerison + `employer/retrieve-geolocations`,
        { params: _params }
      )
  }

  getStudyTags(name: string = null) {
    let _params = new HttpParams();
    if (name) {
      _params = _params.append("name_en", name);
    }
    return this.http
      .get(
        environment.baseUrlWs + environment.wsVerison + `employer/study-tags`,
        { params: _params }
      )
  }

  getJobStudyTags(name: string = null) {
    let _params = new HttpParams();
    if (name) {
      _params = _params.append("name_en", name);
    }
    return this.http
      .get(
        environment.baseUrlWs + environment.wsVerison + `employer/study-tags`,
        { params: _params }
      )
      .pipe(
        map((r: any) => (r = r.list)),
        tap((r) => console.log(r)),
        tap((r: any) => r.map((e: any) => (e.name = e.name_en))),
        tap((r) => console.log(r))
      ) as Observable<any>;
  }

  getJobMacroStudyTag(name: string = null) {
    let _params = new HttpParams();
    if (name) {
      _params = _params.append("name", name);
      return this.http.get(
        environment.baseUrlWs +
        environment.wsVerison +
        `employer/job-macro-study-tags`,
        { params: _params }
      ) as Observable<any>;
    } else {
      return of(this.jobMacroStudyTags);
    }
  }

  getJobCountries(query: string = null): Observable<CountryModel[]> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/job-countries`;

    let _params = new HttpParams();
    if (query) {
      _params = _params.append("query", query);
    }

    return this.http.get(url, { params: _params }) as Observable<
      CountryModel[]
    >;
  }

  getAddresses(
    query: string,
    language: string = "en"
  ): Observable<AddressModel[]> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}/employer/addresses`;
    let params = new HttpParams();
    params = params.append("address", query);
    // params = params.append("language", language);
    return this.http.get(url, { params: params }) as Observable<AddressModel[]>;
  }

  getJobUniversities(name: string = null, country_ids?: any[]) {
    let _params = new HttpParams();
    if (country_ids && country_ids.length > 0) {
      country_ids.forEach((c) => {
        _params = _params.append("countries_ids", String(c.id));
      });
    }
    if (name) {
      _params = _params.append("name", name);
    }
    return this.http.get(
      environment.baseUrlWs +
      environment.wsVerison +
      `employer/job-universities`,
      { params: _params }
    ) as Observable<any>;
  }

  getEnhancements(): Observable<EnhancementsEntity[]> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/enhancements`;
    return this.http.get(url) as Observable<EnhancementsEntity[]>;
  }

  getBenefits(): Observable<BenefitsEntity[]> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/benefits`;
    return this.http.get(url) as Observable<BenefitsEntity[]>;
  }

  getLanguages(): Observable<CommonLanguageModel[]> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/languages`;
    return this.http.get(url) as Observable<CommonLanguageModel[]>;
  }

  getGeolocationsByJobId(
    id: number,
    page: number,
    limit: number,
    query: string
  ): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/geolocations/job-offers/${id}/?limit=${limit}&page=${page}&query=${query}`;
    return this.http.get(url) as Observable<CommonLanguageModel[]>;
  }

  getGeolocationsByExperienceId(
    id: number,
    page: number,
    limit: number,
    query: string
  ): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/geolocations/webinars/${id}/?limit=${limit}&page=${page}&query=${query}`;
    return this.http.get(url) as Observable<CommonLanguageModel[]>;
  }

  getInstitutesFromJobOfferId(
    jobOfferId: number,
    query: string,
    page: number = 0,
    limit: number = 20
  ): Observable<InstitutesFromJobOfferIdModel> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/institutes/job-offers/${jobOfferId}?limit=${limit}&page=${page}&query=${query}`;
    return this.http.get(url) as Observable<InstitutesFromJobOfferIdModel>;
  }

  getStudyTagsFromJobOfferId(
    jobOfferId: number,
    query: string,
    page: number = 0,
    limit: number = 20
  ): Observable<StudyTagsFromJobOfferIdModel> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/job-study-tags/${jobOfferId}?limit=${limit}&page=${page}&name=${query}`;
    return this.http.get(url) as Observable<StudyTagsFromJobOfferIdModel>;
  }

  getTagsFromJobOfferId(
    jobOfferId: number,
    query: string,
    page: number = 0,
    limit: number = 20
  ): Observable<TagsFromJobOfferIdModel> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/tags/job-offers/${jobOfferId}?limit=${limit}&page=${page}&query=${query}`;
    return this.http.get(url) as Observable<TagsFromJobOfferIdModel>;
  }

  getJobFromUrl(jobOfferUrl: string): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/jobs/job-from-url`;
    return this.http.post(url, { url: jobOfferUrl }) as Observable<any>;
  }

  get jobFromUrl(): any {
    return this._jobFromUrl;
  }

  set jobFromUrl(data: any) {
    this._jobFromUrl = data;
  }
}
